<template>
  <div>
    <!-- Page Content -->
    <div class="bg-image">
      <router-view/>
    </div>
    <!-- END Page Content -->
    <footer id="page-footer" class="bg-body-light">
      <div class="content py-0">
        <div class="row font-size-sm">
          <div class="col-sm-6 order-sm-2 mb-1 mb-sm-0 text-center text-sm-right">
            <a @click="togglePpModal(true)" href="javascript:void(0)">{{$t('layout.pageFooter.privacyPolicy')}}</a> <span class="mx-1"> | </span>
            {{$t('layout.pageFooter.craftedWith')}} <i class="fa fa-heart text-danger"></i> {{$t('layout.pageFooter.by')}} <a class="font-w600" href="https://eosnation.io" target="_blank">EOS Nation</a>
          </div>
          <div class="col-sm-6 order-sm-1 text-center text-sm-left">
            <router-link :to="{ name: 'dashboard' }" class="font-w600">EOS {{$t('layout.pageFooter.detective')}}</router-link> &copy; <span>2019</span> <span class="mx-1"> | </span> {{$t('layout.pageFooter.language')}}: <a @click="changeLang('en')" href="javascript:void(0)">{{$t('layout.pageFooter.english')}}</a> - <a @click="changeLang('zh')" href="javascript:void(0)">{{$t('layout.pageFooter.chinese')}}</a>
          </div>
        </div>
      </div>
    </footer>
  </div>
</template>

<script>
import { mapMutations } from 'vuex'

export default {
  name: 'Welcome',
  computed: {
    selectedLanguage () {
      return this.$store.state.options.selectedLanguage
    },
    selectedChain () {
      return this.$store.state.options.selectedChain
    }
  },
  methods: {
    ...mapMutations([
      'togglePpModal',
      'changeLanguage'
    ]),
    changeLang (lang) {
      this.changeLanguage(lang)
    }
  }
}
</script>

<style scoped lang="scss">
  .bg-image {
    height: calc(100vh - 40px);
    background-image: url('../../assets/_img/welcome_bg2.jpg');
    background-position: center;
  }
  #page-footer {
    height: 40px !important;
    min-height: 0px !important;
    z-index: 1001;
  }
</style>
